import { FormControl, FormField, FormItem, FormLabel } from "@/src/components/ui/form";
import { FiltersFormT } from "./filters.schema";
import { Checkbox } from "../../../components/ui/checkbox";

const types = [
  "Sailing yacht",
  "Catamaran",
  "Do not display",
  "Gulet",
  "Jet ski",
  "Power catamaran",
  "R.I.B / Speed boat",
  "Other",
  "Motor yacht",
] as const;

export const BoatTypes = () => {
  return (
    <div>
      <h3 className="text-lg font-semibold col-span-full mb-4">Yacht types</h3>
      <FormField<FiltersFormT, "boatType">
        name="boatType"
        render={() => (
          <FormItem className="space-y-0 grid grid-cols-2 gap-2">
            {types.map((item) => (
              <FormField
                key={item}
                name="boatType"
                render={({ field }) => {
                  return (
                    <FormItem className="flex flex-row items-start space-x-3 space-y-0">
                      <FormControl>
                        <Checkbox
                          className="w-6 h-6"
                          checked={field.value?.includes(item)}
                          onCheckedChange={(checked) => {
                            return checked
                              ? field.onChange([...field.value, item])
                              : field.onChange(field.value?.filter((value: any) => value !== item));
                          }}
                        />
                      </FormControl>
                      <FormLabel className="font-normal text-base leading-6">{item}</FormLabel>
                    </FormItem>
                  );
                }}
              />
            ))}
          </FormItem>
        )}
      />
    </div>
  );
};
